import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'shared/components/modals';
import {ActionLink, Button} from 'shared/components';
import {InteractiveAccordionTable} from 'main/components';
import {FormattedMessage} from 'react-intl';
import CompanyDocument from 'main/stores/documents/CompanyDocument';
import Folder from 'main/stores/folders/Folder';
import {endpoints, types} from 'main/tools';
import _ from 'lodash';

const CompanyDocumentNameCell = observer(({model, level}) => {
  const companyDocument = model;
  return (
    <div>
      {!!companyDocument.folderName && level === 0 && <div className='flex align-items-middle mb1'>
        <i className='jumbo mr1 material-icons h4'>arrow_forward</i>
        <span className='jumbo'>{companyDocument.folderName}</span>
      </div>}
      <span>{companyDocument.name}</span>
    </div>
  );
});


const CompanyDocumentEditLink = observer(({model, uiState}) => {
  if (model.documentType === 'static_document') return null;

  const previewUrl = _.get(model, 'originalFile.previewUrl');
  if (!previewUrl) return null;

  return (
    <Button size='sm' className='right' onClick={() => uiState.openAnnotatorModal(model)}>
      <FormattedMessage id='employees.hiring.documents.Edit'/>
    </Button>
  );
});

const COLUMNS = [
  {
    component: CompanyDocumentNameCell,
    width: 11
  }
];

const FOLDER_COLUMNS = [
  {
    attribute: 'name',
    width: 11
  }
];

const LOCALIZATION = {
  emptyStateMessage: 'employees.hiring.documents.No documents to display'
};

const NESTED_ROWS = [
  {attribute: 'companyDocuments'}
];

const ModalContent = observer(({uiState}) => {
  const {employeeId, selectedDocumentIds} = uiState

  return (
    <InteractiveAccordionTable
      wrapInPanel={false}
      showLinks={false}
      showHeaders={false}
      selectable
      onSelectionChange={ids => uiState.setPendingSelectedDocuments(ids)}
      columns={COLUMNS}
      folderColumns={FOLDER_COLUMNS}
      localization={LOCALIZATION}
      folderProxy={{
        endpoint: endpoints.FOLDERS.withParentAndExcludeEmpty(null, selectedDocumentIds),
        model: Folder,
        modelType: types.FOLDER
      }}
      proxy={{
        type: 'async',
        modelType: types.COMPANY_DOCUMENT,
        model: CompanyDocument,
        endpoint: endpoints.COMPANY_DOCUMENTS.withDraftAndExcludedIds(employeeId, '', selectedDocumentIds)
      }}
      canExpand={folder => folder.hasDocuments || folder.hasSubfolders}
      onExpand={(folder, filter) => uiState.fetchFolderChildren(folder, filter)}
      nestedRows={NESTED_ROWS}
      uiState={uiState}
    />
  );
});

const ExistingCompanyDocumentsModal = observer(({uiState}) => {
  return (
    <Modal
      size='md'
      isOpen={uiState.existingDocumentModalOpen}
      onHide={() => uiState.closeExistingDocumentsModal()}
      title='employees.hiring.documents.Select documents for employee'
    >
      {uiState.existingDocumentModalOpen && <ModalContent uiState={uiState}/>}
      <ModalButtons
        onSave={() => uiState.saveSelectedDocuments()}
        onCancel={() => uiState.closeExistingDocumentsModal()}
      />
    </Modal>
  );
});

export default ExistingCompanyDocumentsModal;
